import { axiosRef } from '../../../api';
import { getDashSeparatedDate } from '../../fuctions';
import { mapResponseLegToTableLeg } from '../functions';
import { LegsQueryPayload } from '../interfaces';

export default async function getLegs(
  payload: LegsQueryPayload,
  setLoading: (loading: boolean) => void,
  isAdmin: boolean,
) {
  let url = `${isAdmin ? '/admin/legs' : '/legs'}?`;
  url += 'shipment_status=All&';

  if (payload?.subAccountNumber) {
    url += `account=${payload.subAccountNumber}&`;
  }
  if (payload?.search) {
    url += `search=${payload.search}&`;
  }
  if (payload?.startDate && payload?.endDate) {
    url += `start_date=${getDashSeparatedDate(payload.startDate)}&`;
    url += `end_date=${getDashSeparatedDate(payload.endDate)}&`;
  } else {
    return {
      legs: [],
      legsCount: 0,
      legsPages: 0,
    };
  }
  if (payload?.userEmail) {
    url += `username=${payload.userEmail}&`;
  }
  if (payload?.page) {
    url += `page=${payload.page}&`;
  }
  if (payload?.pageSize) {
    url += `page_size=${payload.pageSize}`;
  }

  try {
    setLoading(true);
    const response = await axiosRef.get(url);

    if (!response?.data?.is_error) {
      setLoading(false);
      const content = response.data.content;
      return {
        legs: content.data.map(mapResponseLegToTableLeg),
        legsCount: content.count,
        legsPages: content.pages,
      };
    }

    setLoading(false);
    return {
      legs: [],
      legsCount: 0,
      legsPages: 0,
    };
  } catch (error) {
    setLoading(false);
    return {
      legs: [],
      legsCount: 0,
      legsPages: 0,
    };
  }
}
